import PropTypes from "prop-types";
import Avatar from "@/components/common/Avatar";
// import { TrendingUpOutlined } from '../../../../config/antd';
import LP from "@/assets/images/lp.png";
import PDP from "@/assets/images/pdp.png";
import APC from "@/assets/images/apc.png";
import NNPP from "@/assets/images/nnpp.png";

// Mock candidate data
const candidatesData = [
  {
    id: 1,
    name: "Olusegun Obasanjo",
    party: "State Democratic Party (SDC)",
    partyLogo: PDP,
    avatar: null,
    votes: 2198901,
    percentage: 20,
  },
  {
    id: 2,
    name: "Bola Ahmed Tinubu",
    party: "All Progressives Congress (APC)",
    partyLogo: APC,
    avatar: null,
    votes: 2099841,
    percentage: 19,
  },
  {
    id: 3,
    name: "Atiku Abubakar",
    party: "People's Democratic Party (PDP)",
    partyLogo: PDP,
    avatar: null,
    votes: 2040331,
    percentage: 16,
  },
  {
    id: 4,
    name: "Peter Obi",
    party: "Labor Party (LP)",
    partyLogo: LP,
    avatar: null,
    votes: 1990934,
    percentage: 10,
  },
  {
    id: 5,
    name: "Temitope Williams",
    party: "All People's Party Alliance (APPA)",
    partyLogo: NNPP,
    avatar: null,
    votes: 1934004,
    percentage: 7,
  },
];

const CandidateRow = ({ candidate, votes, percentage }) => (
  <div className="flex items-center justify-between p-4 bg-white rounded-lg border border-gray-100">
    <div className="flex items-center gap-4">
      <div className="relative">
        <Avatar
          src={candidate.avatar}
          size={56}
          childAvatar={{ src: candidate.partyLogo, alt: candidate.party }}
        />
      </div>
      <div>
        <h3 className="text-bold-x mb-1">{candidate.name}</h3>
        <p className="text-small font-medium mb-1">{candidate.party}</p>
        <p className="text-small text-lighterGrey">
          {votes.toLocaleString()} votes
        </p>
      </div>
    </div>
    <span className="text-bold font-bold text-[#003153]">{percentage}%</span>
  </div>
);

CandidateRow.propTypes = {
  candidate: PropTypes.object,
  votes: PropTypes.number,
  percentage: PropTypes.number,
};

const CandidatesVersus = () => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-bold-x mb-4">
            My Candidates Versus Other Contestants
          </h2>
        </div>
        <div className="flex items-center gap-2"></div>
      </div>

      <div className="flex justify-between text-bold font-normal text-lighterGrey mb-6">
        <span>Candidate and Party</span>
        <span>Votes</span>
      </div>

      <div className="space-y-4">
        {candidatesData.map((candidate) => (
          <CandidateRow
            key={candidate.id}
            candidate={candidate}
            votes={candidate.votes}
            percentage={candidate.percentage}
          />
        ))}
      </div>
    </div>
  );
};

export default CandidatesVersus;
